
import { routes } from '../config/api_routes'


export const itemService = {
    getItemNutritions: (formData) => window.axios.post(routes.getItemNutritions, formData),

	updateNutritions: (formData) => window.axios.post(routes.updateNutritions, formData),

	getItemRatings: (formData) => window.axios.post(routes.getItemRatingsApi, formData),

	deleteItemRating: (formData) => window.axios.post(routes.deleteItemRatingApi, formData),
}